import React from "react";
import Head from "../Components/Head";
import { useNavigate } from "react-router-dom";
import documentService from "../Services/documentService";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { IoDocumentOutline } from "react-icons/io5";
import { VscPackage } from "react-icons/vsc";
import { FiEdit3 } from "react-icons/fi";
import { TbReceipt } from "react-icons/tb";

const Documents = () => {
  const [docs, setDocs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const getDocs = async () => {
      try {
        const response = await documentService.fetchDocAll();
        setDocs(response.documents);
      } catch (error) {
        toast.error("Error fetching news");
      }
    };
    getDocs();
  }, []);

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <Head
        heading={"Documents"}
        button_text={"Add Document"}
        navigation={() => navigate("./add")}
      />
      {/* DELETE NOT MODEL  */}
      <div className="table-div">
        <table className="w-full">
          <thead className="border-y-2 text-left text-black text-[10px]">
            <tr>
              <th className="py-4 text-center w-[1%]">Sr no.</th>
              {/* <th className="rounded-tl-lg py-4 pl-4 w-[3%]">Title</th> */}
              <th className="py-4 text-center w-[2%]">Date</th>
              <th className="py-4 rounded-tl-lg text-center w-[2%]">
                Customer or Supplier
              </th>
              <th className="py-4 text-left w-[6%]">Note</th>
              <th className="py-4 text-center w-[2%]">Amount</th>
              <th className="py-4 text-center w-[1%]">Document</th>
              <th className="py-4 text-center w-[1%]">Packing List</th>
              <th className="py-4 text-center w-[1%]">Delivery Note</th>
              <th className="py-4 text-center w-[1%]">Payment Receipt</th>
              <th className="py-4 text-center w-[1%]">Custom Document</th>
            </tr>
          </thead>
          <tbody>
            {docs.map((doc, index) => (
              <tr
                key={doc.id}
                className="bg-accent border-b border-gray-100 text-left"
              >
                <td className="py-4 text-center font-bold text-blue-500">
                  {index + 1}.
                </td>
                <td className="py-4 text-center font-semibold">
                  {new Date(doc.date)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, "-")}
                </td>

                <td className="py-4 text-center font-semibold text-cyan-600">
                  {doc.customer_company_name || doc.supplier_company ? (
                    <span>
                      {doc.customer_company_name ?? doc.supplier_company}
                    </span>
                  ) : (
                    <span className="text-gray-400 italic">No Company</span>
                  )}
                </td>

                <td className="py-4 text-[10px] text-left">{doc.note}</td>
                <td className="py-4 text-center">{doc.amount}</td>
                <td className="py-4 text-center">
                  <div className="flex justify-center gap-6">
                    <button
                      title="View Document"
                      onClick={() => window.open(doc.docfile, "_blank")}
                    >
                      <IoDocumentOutline className="text-base text-red-500" />
                    </button>
                  </div>
                </td>
                <td className="py-4 text-center">
                  <div className="flex justify-center gap-6">
                    <button
                      title="Packing List"
                      onClick={() => window.open(doc.pack_list, "_blank")}
                    >
                      <VscPackage className="text-base text-blue-500" />
                    </button>
                  </div>
                </td>

                <td className="py-4 text-center ">
                  <div className="flex justify-center gap-6">
                    <button
                      title="Delivery Note"
                      onClick={() => window.open(doc.delivery_note, "_blank")}
                    >
                      <FiEdit3 className="text-base text-yellow-500" />
                    </button>
                  </div>
                </td>

                <td className="py-4 text-center">
                  <div className="flex justify-center gap-6">
                    <button
                      title="Payment Receipt"
                      onClick={() => window.open(doc.payment_receipt, "_blank")}
                    >
                      <TbReceipt className="text-base text-red-500" />
                    </button>
                  </div>
                </td>

                <td className="py-4 text-center">
                  <div className="flex justify-center gap-6">
                    <button
                      title="Custom Document"
                      onClick={() => window.open(doc.custom_doc, "_blank")}
                    >
                      <IoDocumentOutline className="text-base text-blue-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </main>
  );
};

export default Documents;
